module.exports = __webpack_public_path__ + "media/images/pt/altruism-segment-40c1b6632e9d4682a1113b39f3424fa7.jpg";